// @flow
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import PageContentWrapper from "../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
import { RATES } from "../locales/namespaces";
import ContributionRate from "./contributionRate";
import SalaryIncreaseRate from "./salaryIncreaseRate";
import ExtraContributionRate from "./extraContributionRate";
//
type Props = {};

const Rates = (props: Props) => {
	const { t } = useTranslation(RATES)

	return (
		<Box className="specialties_index">
			<PageContentWrapper> {/* Wrapper component που δημιουργεί συγκεκριμένο style γύρω από τα grid και τον τίτλο στην index. */}
				<PageTitle
					title={t('Rates')}/>
				<Grid container spacing={2}>
					<Grid size={{sm:12, md:4}}>
						<ContributionRate/>
					</Grid>
					<Grid size={{sm:12, md:4}}>
						<SalaryIncreaseRate/>
					</Grid>
					<Grid size={{sm:12, md:4}}>
						<ExtraContributionRate/>
					</Grid>
				</Grid>
				
			</PageContentWrapper>
		</Box>
	);
};
//
export default Rates
// export default withPermissionHOC(Rates, [access_skills])